import React, {Component} from 'react';
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import ScheduleResults from "../../../components/ScheduleResults/ScheduleResults";
import BackgroundColorMobile from '../../../components/BackgroundColorMobile/BackgroundColorMobile';

import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {requestAirportData} from "../../../actions/airportDataActions";
import {requestServiceLevelData} from "../../../actions/serviceLevelDataActions";
import {requestScheduleData, resetNoResultsScheduleData} from "../../../actions/schedulesDataActions";

import queryString from "query-string";

import {REQUEST_NON_REV_AND_REV_FACILITIES_DATA} from "../../../actions/nonRevAndRevFacilitiesActions";
import Skeleton from "../../../components/Skeleton/Skeleton";

class FlightSchedulesResults extends Component {

  state = {};

  componentDidMount() {
    this.props.requestAirportData();
    if (!this.props.nonRevAndRevFacilities) {
      this.props.getNonRevAndRevFacilities();
    }
  }

  componentDidUpdate(prevProps) {

    let params = queryString.parse(this.props.location.search);

    if (this.props.nonRevAndRevFacilities && !this.props.requestedScheduleData && !this.props.noResults) {
      params.nonRevAndRevFacilities = this.props.nonRevAndRevFacilities;
      this.props.getScheduleData(params);
    }
  }

  getQueryString() {

    let params = queryString.parse(this.props.location.search);
    return Object.keys(params).map(key => key + '=' + params[key]).join('&');

  }

  getPageView() {
    let originLocation;
    let originLocationCityState;
    let destinationLocation;
    let destinationLocationCityState;

    let origin;
    let destination;

    if (this.props.nonRevAndRevFacilities) {

      originLocation = this.props.nonRevAndRevFacilities ? this.props.nonRevAndRevFacilities.filter((item) => {
        return item.airportCodeIATA === queryString.parse(this.props.location.search).origin
      })[0] : null;

      origin = originLocation.airportCodeIATA;

      originLocationCityState = originLocation.facilityInfo.location.cityName.replace(/\w\S*/g, c => c[0].toUpperCase() + c.substr(1).toLowerCase()) +
        " (" + originLocation.airportName.replace(/\w\S*/g, c => c[0].toUpperCase() + c.substr(1).toLowerCase()) + ")" +
        ", " +
        originLocation.facilityInfo.location.stateName;

      destinationLocation = this.props.nonRevAndRevFacilities ? this.props.nonRevAndRevFacilities.filter((item) => {
        return item.airportCodeIATA === queryString.parse(this.props.location.search).destination
      })[0] : null;

      destination = destinationLocation.airportCodeIATA;

      destinationLocationCityState = destinationLocation.facilityInfo.location.cityName.replace(/\w\S*/g, c => c[0].toUpperCase() + c.substr(1).toLowerCase()) +
        " (" + destinationLocation.airportName.replace(/\w\S*/g, c => c[0].toUpperCase() + c.substr(1).toLowerCase()) + ")" +
        ", " +
        destinationLocation.facilityInfo.location.stateName;
    }

    return (
      <div className="wrapper mtl">
        <Breadcrumbs pageTitle="Results"/>
        <div className="cargo-schedule-results">
          <div className="cargo-schedule-results__top">
            <h1 className="cargo-schedule-results__title">Cargo Flight Schedules:</h1>
            <div className="destinations">
              <div className="destinations__departure">{origin}</div>
              <img className="destinations__icon" src="./assets/ship/CargoFlightSchedules/plane.svg" alt=""/>
              <div className="destinations__arrival">{destination}</div>
              <button className="cargo-schedule-results__modify-button regular-button"
                      onClick={() => {
                        this.props.history.push({
                          pathname: '/ship/flight-schedules/',
                          search: this.getQueryString()
                        });
                      }}>Modify
              </button>
            </div>
          </div>
          <p className="cargo-schedule-results__description mbl">
            <span className="text-capitalize">{originLocationCityState}</span> to <span
            className="text-capitalize">{destinationLocationCityState}</span>
          </p>
          <p className="mtl">
            * Date tabs represent drop off date.
          </p>
          <div className="cargo-schedule-results__middle">
            {this.getResultsBody()}
          </div>
        </div>
        <BackgroundColorMobile/>
      </div>
    )
  }

  getResultsBody() {
    if (this.props.error || this.props.noResults) {
      let params = queryString.parse(this.props.location.search);

      let qs = Object.keys(params).map(key => key + '=' + params[key]).join('&');

      this.props.history.push({
        pathname: '/ship/flight-schedules/',
        search: qs
      });
      return null;
    } else {
      return (<ScheduleResults history={this.props.history}
                               routes={this.props.scheduleData}
                               segmentTypes={this.props.segmentTypes}
                               nonRevAndRevFacilities={this.props.nonRevAndRevFacilities}
                               location={this.props.location}/>);
    }
  }

  render() {
    if (this.props.error || this.props.noResults) {
      return this.getPageView();
    }
    return this.props.scheduleData.length > 0 ? this.getPageView() : <Skeleton type="LONG_CONTENT_PAGE"/> ;
  }
}

FlightSchedulesResults.propTypes = {
  scheduleData: PropTypes.array.isRequired,
  getScheduleData: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  scheduleData: state.scheduleData.items,
  segmentTypes: state.scheduleData.segmentTypes,
  noResults: state.scheduleData.noResults,
  error: state.scheduleData.error,
  requestedScheduleData: state.scheduleData.requestedScheduleData,
  nonRevAndRevFacilities: state.nonRevAndRevFacilitiesData.nonRevAndRevFacilities
});

const mapDispatchToProps = dispatch => ({
  getNonRevAndRevFacilities: () => dispatch({type: REQUEST_NON_REV_AND_REV_FACILITIES_DATA}),
  getScheduleData: data => {
    dispatch(requestScheduleData(data))
  },
  requestAirportData,
  requestServiceLevelData,
  resetNoResultsScheduleData
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FlightSchedulesResults));



// WEBPACK FOOTER //
// ./src/pages/ship/FlightSchedules/FlightSchedulesResults.js